import * as Sentry from '@sentry/react';

import { env } from './env';

const allowedEnv = ['staging', 'production'] as const;

export const initSentry = () => {
  if (!env.sentryDsn || !allowedEnv.includes(env.appEnv)) return;

  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.appEnv,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
    sendDefaultPii: true,
  });

  window.addEventListener('unhandledrejection', (event) => {
    const message = event.reason?.message || '';
    if (message.includes('Loading chunk') || message.includes('ChunkLoadError')) {
      Sentry.captureException(event.reason);
      window.location.reload();
    }
  });
};
